module.exports = __webpack_public_path__ + "img/PPP.52bc31f4.jpg";